<permission-checker [roles]="roles" (contentInit)="initContent()" (rolesLoaded)="callerRolesUpdated($event)">
  <div class="content-holder">
      <contest-select-panel [competitionId]="competitionId"
                            [contest]="contest"
                            [mobileView]="mobileView"
                            [showDetails]="false"
                            (selected)="contestSelected($event)"></contest-select-panel>

      <item-select [roles]="roles"
                   label="Select Region"
                   i18n-label="User Profile|School region select input label@@user-profile-school-region-select-input-label"
                   [disabled]="!allowRegionSelect"
                   [compareWith]="compareRegions"
                   [displayWith]="displayRegion"
                   [loadWith]="loadRegions"
                   [selectedItem]="region"
                   (selected)="regionSelected($event)"></item-select>

      <div *ngIf="contest && region" fxLayout="row wrap" fxLayout.lt-md="column" class="stats-holder">
        <bar-chart fxFlex="33%"
                   class="stats-card"
                   title="Region Enrollments"
                   i18n-title="Stats|Region Enrol stats title@@stats-region-enrol-stats-title"
                   noContentTitle="Region enrollment stats data is missing for the selected contest"
                   i18n-noContentTitle="Stats|Region Enrol stats missing title@@stats-region-enrol-stats-missing-title"
                   noContentDetails="Stats will be added when students start to enrol for the contest"
                   i18n-noContentDetails="Stats|Region Enrol stats missing details@@stats-region-enrol-stats-missing-details"
                   [labels]="paymentStatsLabels"
                   [data]="paymentStats"></bar-chart>

        <div class="fill-space"></div>

        <doughnut-chart fxFlex="33%"
                        class="stats-card grade-stats-card"
                        title="Enrollment by Grade"
                        i18n-title="Stats|School Enrol stats grade chart title@@stats-school-enrol-stats-grade-chart-title"
                        noContentTitle="Grade enrollment stats data is missing for the selected contest"
                        i18n-noContentTitle="Stats|Grade Enrol stats missing title@@stats-grade-enrol-stats-missing-title"
                        noContentDetails="Stats will be added when students start to enrol for the contest"
                        i18n-noContentDetails="Stats|Grade Enrol stats missing details@@stats-grade-enrol-stats-missing-details"
                        [labels]="gradeStatsLabels"
                        [data]="gradeStats"></doughnut-chart>

        <div class="fill-space"></div>

        <doughnut-chart fxFlex="33%"
                        class="stats-card status-stats-card"
                        title="Participant Status"
                        i18n-title="Stats|School Enrol stats status chart title@@stats-school-enrol-stats-status-chart-title"
                        noContentTitle="Status enrollment stats data is missing for the selected contest"
                        i18n-noContentTitle="Stats|Status Enrol stats missing title@@stats-status-enrol-stats-missing-title"
                        noContentDetails="Stats will be added when students start to enrol for the contest"
                        i18n-noContentDetails="Stats|Status Enrol stats missing details@@stats-status-enrol-stats-missing-details"
                        [labels]="userStatusStatsLabels"
                        [data]="userStatusStats"></doughnut-chart>

        <school-enrol-stats fxFlex="100%"
                            class="stats-car"
                            [mobile]="mobileView"
                            [region]="region"
                            [stats]="schoolStats"
                            [pageToken]="schoolStatsPageToken"
                            (loadNextPage)="loadSchoolStats(contest, region)"></school-enrol-stats>
      </div>

  </div>
</permission-checker>
